import React from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import Button from "components/Button/Button";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import TextArea from "components/TextArea/TextArea";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {calc_eGFR, dateToYMD, ymdToDate} from './REGComUtil'; //
import SelectBox from "../../components/SelectBox/SelectBox";
import Radio2 from "../../components/Radio/Radio2";
import RadioGroup from "../../components/Radio/RadioGroup";
import Checkbox from "../../components/Checkbox/Checkbox";


const RenderHtml = (props) => {

    let htmlTab0=<></>;  let htmlTab1=<></>;  let htmlTab2=<></>; let htmlTab3=<></>;


    const radioOptions = [
         {mapCd: "M00002", value: "1", label: "Stable angina"}, {mapCd: "M00002", value: "2", label: "Unstable angina"}
        ,{mapCd: "M00002", value: "3", label: "NSTEMI"}, {mapCd: "M00002", value: "4", label: "STEMI"}
        ,{mapCd: "M00002", value: "5", label: "Silent ischemia"}, {mapCd: "M00002", value: "6", label: "Recent MI"}
        ,{mapCd: "M00002", value: "7", label: "Vasospastic angina"}, {mapCd: "M00002", value: "8",label: "Screening for CAD"}
        ,{mapCd: "M00002", value: "9", label: "Aborted SCD"}, {mapCd: "M00002", value: "10", label: "Other"}
        ,{mapCd: "M00010",value: "1", label: "Yes"},{mapCd: "M00010",value: "2", label: "No"},{mapCd: "M00010",value: "3", label: "Unknown"}
        ,{mapCd: "M00015",value: "1", label: "Never"}
        ,{mapCd: "M00015",value: "2", label: "Current"}
        ,{mapCd: "M00015",value: "3", label: "Ex-Smoker"}
        ,{mapCd: "M00015",value: "4", label: "Unknown"}
        ,{mapCd: "M00016",value: "1", label: "Yes"},{mapCd: "M00016",value: "2", label: "No"},{mapCd: "M00016",value: "3", label: "Unknown"}
        ,{mapCd: "M00017",value: "1", label: "Yes"},{mapCd: "M00017",value: "2", label: "No"},{mapCd: "M00017",value: "3", label: "Unknown"}
        ,{mapCd: "M00018",value: "1", label: "Yes"},{mapCd: "M00018",value: "2", label: "No"},{mapCd: "M00018",value: "3", label: "Unknown"}
        ,{mapCd: "M00019",value: "1", label: "Yes"},{mapCd: "M00019",value: "2", label: "No"},{mapCd: "M00019",value: "3", label: "Unknown"}
        ,{mapCd: "M00020",value: "1", label: "Yes"},{mapCd: "M00020",value: "2", label: "No"},{mapCd: "M00020",value: "3", label: "Unknown"}
        ,{mapCd: "M00021",value: "1", label: "Yes"},{mapCd: "M00021",value: "2", label: "No"},{mapCd: "M00021",value: "3", label: "Unknown"}
        ,{mapCd: "M00022",value: "1", label: "Yes"},{mapCd: "M00022",value: "2", label: "No"},{mapCd: "M00022",value: "3", label: "Unknown"}
        ,{mapCd: "M00023",value: "1", label: "Yes"},{mapCd: "M00023",value: "2", label: "No"},{mapCd: "M00023",value: "3", label: "Unknown"}
        ,{mapCd: "M00024",value: "1", label: "Yes"},{mapCd: "M00024",value: "2", label: "No"},{mapCd: "M00024",value: "3", label: "Unknown"}
        ,{mapCd: "M00025",value: "1", label: "HD"},{mapCd: "M00025",value: "2", label: "PD"},{mapCd: "M00025",value: "3", label: "None"}
        ,{mapCd: "M00028",value: "1", label: "Yes"},{mapCd: "M00028",value: "2", label: "No"},{mapCd: "M00028",value: "3", label: "Unknown"}
        ,{mapCd: "M00029",value: "1", label: "Yes"},{mapCd: "M00029",value: "2", label: "No"},{mapCd: "M00029",value: "3", label: "Unknown"}
        ,{mapCd: "M00031",value: "1", label: "Yes"},{mapCd: "M00031",value: "2", label: "No"},{mapCd: "M00031",value: "3", label: "Unknown"}
        ,{mapCd: "M00032",value: "1", label: "Yes"},{mapCd: "M00032",value: "2", label: "No"},{mapCd: "M00032",value: "3", label: "Unknown"}
        ,{mapCd: "M00041",value: "1", label: "Yes"},{mapCd: "M00041",value: "2", label: "No"},{mapCd: "M00041",value: "3", label: "Unknown"}
        ,{mapCd: "M00042",value: "1", label: "Yes"},{mapCd: "M00042",value: "2", label: "No"},{mapCd: "M00042",value: "3", label: "Unknown"}
        ,{mapCd: "M00043",value: "1", label: "Warfarin (Coumadin)"},{mapCd: "M00043",value: "2", label: "Dabigatran"},{mapCd: "M00043",value: "3", label: "Apixaban"}
        ,{mapCd: "M00043",value: "4", label: "Rivaroxaban"},{mapCd: "M00043",value: "5", label: "Edoxaban"},{mapCd: "M00043",value: "6", label: "Other"}
        ,{mapCd: "M00047",value: "1", label: "Yes"},{mapCd: "M00047",value: "2", label: "No"},{mapCd: "M00047",value: "3", label: "Unknown"}
        ,{mapCd: "M00048",value: "1", label: "Yes"},{mapCd: "M00048",value: "2", label: "No"},{mapCd: "M00048",value: "3", label: "Unknown"}
        ,{mapCd: "M00049",value: "1", label: "Yes"},{mapCd: "M00049",value: "2", label: "No"},{mapCd: "M00049",value: "3", label: "Unknown"}
        ,{mapCd: "M10028",value: "1", label: "ng/mL"},{mapCd: "M10028",value: "2", label: "pg/mL"}
        ,{mapCd: "M10030",value: "1", label: "ng/mL"},{mapCd: "M10030",value: "2", label: "pg/mL"}
        ,{mapCd: "M10032",value: "1", label: "ng/mL"},{mapCd: "M10032",value: "2", label: "pg/mL"}
        ,{mapCd: "M10034",value: "1", label: "ng/mL"},{mapCd: "M10034",value: "2", label: "pg/mL"}
        ,{mapCd: "M10039",value: "1", label: "NA"},{mapCd: "M10039",value: "2", label: "(-)"},{mapCd: "M10039",value: "3", label: "(+)"}
        ,{mapCd: "M11028",value: "1", label: "1VD"},{mapCd: "M11028",value: "2", label: "2VD"},{mapCd: "M11028",value: "3", label: "3VD"}
        ,{mapCd: "M11040",value: "1", label: "Single access"},{mapCd: "M11040",value: "2", label: "Multiple access"}
        ,{mapCd: "M11048",value: "1", label: "Yes"},{mapCd: "M11048",value: "2", label: "No"}
        ,{mapCd: "M11049",value: "1", label: "Index PCI"},{mapCd: "M11049",value: "2", label: "Staged PCI"}
        ,{mapCd: "M11050",value: "1", label: "Manual(직접 압박만 의미함)"},{mapCd: "M11050",value: "2", label: "Device closer"}


    ];

    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }

    const activeFlagObj = props.activeFlagObj;    //컴포넌트 이벤트

    const btnAllObj = [
         {mapCd: "M00029", tarId:"M00031", tarVal:"2"},{mapCd: "M00029", tarId:"M00032", tarVal:"2"}
        ,{mapCd: "M00029", tarId:"M00041", tarVal:"2"},{mapCd: "M00029", tarId:"M00042", tarVal:"2"}
        ,{mapCd: "M00030", tarId:"M00031", tarVal:"3"},{mapCd: "M00030", tarId:"M00032", tarVal:"3"}
        ,{mapCd: "M00030", tarId:"M00041", tarVal:"3"},{mapCd: "M00030", tarId:"M00042", tarVal:"3"}
        ,{mapCd: "M00045", tarId:"M00047", tarVal:"2"},{mapCd: "M00045", tarId:"M00048", tarVal:"2"}
        ,{mapCd: "M00045", tarId:"M00049", tarVal:"2"}
        ,{mapCd: "M00046", tarId:"M00047", tarVal:"3"},{mapCd: "M00046", tarId:"M00048", tarVal:"3"}
        ,{mapCd: "M00046", tarId:"M00049", tarVal:"3"}

        //LAB DATA
        ,{mapCd: "M10001", tarId:"M10002", tarVal:"ND"},{mapCd: "M10001", tarId:"M10003", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10004", tarVal:"ND"},{mapCd: "M10001", tarId:"M10005", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10006", tarVal:"ND"},{mapCd: "M10001", tarId:"M10007", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10008", tarVal:"ND"},{mapCd: "M10001", tarId:"M10009", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10010", tarVal:"ND"},{mapCd: "M10001", tarId:"M10011", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10012", tarVal:"ND"},{mapCd: "M10001", tarId:"M10013", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10014", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10015", tarVal:"ND"},{mapCd: "M10001", tarId:"M10016", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10017", tarVal:"ND"},{mapCd: "M10001", tarId:"M10018", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10019", tarVal:"ND"},{mapCd: "M10001", tarId:"M10020", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10021", tarVal:"ND"},{mapCd: "M10001", tarId:"M10022", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10023", tarVal:"ND"},{mapCd: "M10001", tarId:"M10024", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10025", tarVal:"ND"},{mapCd: "M10001", tarId:"M10026", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10027", tarVal:"ND"},{mapCd: "M10001", tarId:"M10028", tarVal:""}
        ,{mapCd: "M10001", tarId:"M10029", tarVal:"ND"},{mapCd: "M10001", tarId:"M10030", tarVal:""}
        ,{mapCd: "M10001", tarId:"M10031", tarVal:"ND"},{mapCd: "M10001", tarId:"M10033", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10035", tarVal:"ND"},{mapCd: "M10001", tarId:"M10036", tarVal:"ND"}
        ,{mapCd: "M10001", tarId:"M10037", tarVal:"ND"},{mapCd: "M10001", tarId:"M10038", tarVal:"ND"}

    ];

    // const getActiveValue = (mapCd, colName='chkFlag') =>{
    //     const targetItem = activeFlagObj.find(item => item.mapCd === mapCd);
    //     if (targetItem && targetItem.hasOwnProperty(colName)) {
    //         return targetItem[colName];
    //     } else {
    //         return ""; // 또는 다른 적절한 값 (null, 에러 처리 등)
    //     }
    // }

    const activeEvent = (mapCd, value="") =>{
        /* activeEvent :
         * - 이벤트 발생시 코드와 값을 기준으로 컴포넌트 활성화/비활성화를 제어하는 상태값 변경
         * - 데이터가 존재하는 activeFlag 필드 값을 변경하여 제어( readOlny 같은 옵션에서 값을 참조하는방식)
         */
        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                    props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
            });
        }

        /* eGFR계산 ******************************* */
        if(mapCd==='M10012'){
            props.setDtlValue('M10014',calc_eGFR(value, props.getMstValue('age'), props.getMstValue('sex')))
        }
        if(mapCd==='M10013'){
            props.setDtlValue('M10015',calc_eGFR(value, props.getMstValue('age'), props.getMstValue('sex')))
        }
    }

    const btnAllEvent = (mapCd) => {
        /* 일괄 선택 처리 */
        const allObj = btnAllObj.filter(item => item.mapCd === mapCd);
         if (allObj.length > 0) {
             allObj.forEach(item => {
                 props.setDtlValue(item.tarId, item.tarVal);
                 activeEvent(item.tarId, item.tarVal);
            });
        }
    };

    /* Event ****************************************************************************** */

    const compValue = (mstId) => {
        return props.getDtlValue(mstId);
    }

    const compChange = (mapCd, value) => {
        props.setDtlValue(mapCd, value);
        activeEvent(mapCd, value);

        switch (mapCd) {
            case "M00004" : case "M00005":
                const input = value;
                const numericOnly = input.replace(/[^0-9]/g, '');  // 숫자만 남기기
                props.setDtlValue(mapCd, numericOnly);
            break;
            default:
                props.setDtlValue(mapCd, value);
            break;

        }

        activeEvent(mapCd, value);


    }

    const actNd = (mapCd, value="") =>{

        switch (mapCd) {
            case "M10027" : case "M10029" :case "M10031" :case "M10033" :
                props.setDtlValue(mapCd, value);
                activeEvent(mapCd, value);
            break;

            default:
                props.setDtlValue(mapCd, value);
            break;
        }




    }

    /* ****************************************************************************** Event */




    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };


    htmlTab0 =
        <>
            <div className={styleCom.title_wrap}>
                <h3>연구등록 및 인구통계학적 조사</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop:"10px", padding:"20px"}}>
                <Table variant='default' rowCnt={4} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                    <div>등록기관</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('hsptNm')}
                                        unit={""} readOnly={true}/></div>
                    <div>대상자 번호</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('subjectCd')}
                                        unit={""} readOnly={true}/></div>
                    <div>대상자 영문 이니셜</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('initial')}
                                        unit={""} readOnly={true}/></div>
                    <div>동의서 취득일</div>
                    <DatePicker selDate={ymdToDate(props.getMstValue('acquisitionDt'))}
                                dateFormat={'yyyy-MM-dd'} isDisabled={true}

                    />
                    <div>PCI 시행일</div>
                    <DatePicker selDate={ymdToDate(props.getMstValue('pciDt'))}
                                dateFormat={'yyyy-MM-dd'} isDisabled={true}/>
                    <div>연령(만)</div>
                    <div><InputUnitText type={"text"} value={props.getMstValue('age')}
                                        unit={"세"} readOnly={true}
                    /></div>
                    <div>성별</div>
                    <div>
                        <SwitchGroup value={props.getMstValue("sex")}
                                     items={{"남성": "M", "여성": "F"}} isDisabled={true}/>
                    </div>
                    <div>대상자 서면 동의일</div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getMstValue('subjectAgreeDt'))}
                                    dateFormat={'yyyy-MM-dd'} isDisabled={true}
                        />
                    </div>
                </Table>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>

                <h3>선정/제외 기준평가</h3>
                <Table variant='Vertical' rowCnt={15} colSize={['75%', '25%']} rowSize={'56px'}>
                    <div className={style.cellTyp1}>상기 시험 대상자는 선정/제외 기주을 만족하고, 관찰연구 참여에 적합합니까?</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("validYn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={"col_merge"}
                         style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                        <span className={style.cellHeader}>Inclusion Criteria</span>
                    </div>

                    <div className={style.cellTyp1}>1. 만 19 세 이상의 성인</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include1Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>2. 최근 1개월 내에 관상동맥질환(모든 종류의 협심증, 심근경색)으로 확인된 병변에
                        EluNIR 스텐트(EluNIR™, EluNIR-PERL™)를 사용하여 관상동맥중재술을 받은 환자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include2Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>3. 본 연구에 자발적으로 참여를 결정하고 서면 동의한 자</div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("include3Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={"col_merge"}
                         style={{justifyContent: 'left', backgroundColor: "#FAFAFA"}}>
                        <span className={style.cellHeader}>Exclusion Criteria</span>
                    </div>
                    <div className={style.cellTyp1}>
                        1. 다음의 약물이나 물질에 대해 알려진 과민증이나 금기가 있는 환자: 헤파린, 아스
                        피린, 클로피도그렐, 리다포롤리무스, 코발트 크롬, 스테인리스스틸, 니켈, 316L
                        금속 및 조영제(단, 조영제에 대한 과민성이 있는 연구대상자라도 스테로이드와 페 니라민에 의해 조절될 수 있는 경우에는 등록이 가능하나, 알려진
                        아나필락시스가 있는
                        경우
                        제외 대상이다.)
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude1Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        2. 출혈 경향이나 혈액 응고 장애의 병력이 있는 경우
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude2Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        3. 임산부, 수유부 또는 가임기 여성 중 본 연구기간 동안 임신을 계획하고 있는 자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude3Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        4. 내원시 심인성 쇽(cardiogenic shock)을 동반한 경우
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude4Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        5. 예상 기대수명이 1년 미만인 자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude5Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        6. 좌심실구혈률(LVEF, left ventricular ejection fraction)이 30% 이하인 경우
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude6Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        7. 등록시 EluNIR 스텐트 외 다른 스텐트를 사용하여 시술 받은 환자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude7Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        8. 의료기기 무작위 배정 연구에 참여 중인 대상자
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude8Yn")}
                                     readonly={true}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                    <div className={style.cellTyp1}>
                        9. 연구자가 본 연구 참여에 부적합하다고 판단한 경우
                    </div>
                    <div className={style.cellTyp2}>
                        <SwitchGroup value={props.getMstValue("exclude9Yn")}
                                     items={{"YES": "Y", "NO": "N"}} isDisabled={true}
                        />
                    </div>
                </Table>
            </div>
        </>;

    htmlTab1 =
        <>
            <div className={styleCom.title_wrap}>
                <h3>입원시 건강정보</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='defualt' rowCnt={3} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>입원일자</div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getDtlValue('M00001'))}
                                    dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setDtlValue('M00001', dateToYMD(date))}/>

                    </div>
                    <div>Clinical diagnosis</div>
                    <div>
                        <div style={{marginTop: "8px"}}>
                            <RadioGroup
                                options={getOptionList('M00002')}
                                colCnt={5}
                                selectedValue={compValue('M00002')}
                                onChange={(val) => compChange('M00002', val)}
                            />
                        </div>
                        <div style={{marginTop: "50px", marginBottom: "5px"}}>
                            <InputUnitText type={"text"} value={props.getDtlValue("M00003")}
                                           onChange={(value) => props.setDtlValue("M00003", value)}
                                           maxLength={30}
                                           readOnly={props.getDtlValue("M00003", 'activeFlag')}
                            />

                        </div>
                    </div>
                    <div>
                        <span className={style.cellText2}>
                            <div className={style.cellText1}>Physical Exam</div>
                            (initial visit at ER or CAG room)</span>
                    </div>
                    <div style={{height: "224px"}}>
                        <table style={{width: "98%"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <Table variant='Vertical' colSize={['50%', '50%']} rowSize={'40px'} rowCnt={2}>
                                        <div>Height</div>
                                        <div>Weight</div>
                                        <div style={{height: "56px"}}>
                                            <InputUnitText type={"string"} unit={"cm"} maxLength={3}
                                                           value={props.getDtlValue('M00004')}
                                                           onChange={(value) => compChange('M00004', value)}/>
                                        </div>
                                        <div>
                                            <InputUnitText type={"string"} unit={"kg"} maxLength={3}
                                                           value={props.getDtlValue('M00005')}
                                                           onChange={(value) => compChange('M00005', value)}/>
                                        </div>
                                    </Table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Table variant='Vertical' colSize={['50%', '50%', '50%']} rowSize={'40px'}
                                           rowCnt={2}>
                                        <div>SBP</div>
                                        <div>DBP</div>
                                        <div>HR</div>
                                        <div style={{height: "56px"}}>
                                            <InputUnitText type={"number"} unit={"mmHg"}
                                                           value={props.getDtlValue('M00006')}
                                                           onChange={(value) => props.setDtlValue('M00006', value)}/>
                                        </div>
                                        <div>
                                            <InputUnitText type={"number"} unit={"mmHg"}
                                                           value={props.getDtlValue('M00007')}
                                                           onChange={(value) => props.setDtlValue('M00007', value)}/>
                                        </div>
                                        <div>
                                            <InputUnitText type={"number"} unit={"bpm"}
                                                           value={props.getDtlValue('M00008')}
                                                           onChange={(value) => props.setDtlValue('M00008', value)}/>
                                        </div>
                                    </Table>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Table>
            </div>

            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <h3>Risk Factor & History</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='defualt' rowCnt={13} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Hypertension</div>
                    <div>
                        <RadioGroup
                            options={[
                                {value: "1", label: "Yes"}, {value: "2", label: "No"}, {value: "3", label: "Unknown"}
                            ]}
                            selectedValue={props.getDtlValue('M00009')}
                            onChange={(val) => props.setDtlValue('M00009', val)}
                        />
                    </div>
                    <div style={{height: "120px"}}>
                        <table>
                            <thead>
                            <tr>
                                <td>
                                    Diabetes
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className={style.cellText2}>(당뇨약 복용중인 경우, 당화혈색소 6.5이상)</span>
                                </td>
                            </tr>
                            </thead>
                        </table>

                    </div>
                    <div>
                        <div style={{display: "block", width: "100%", height: "110px", marginTop: "10px"}}>
                            <RadioGroup
                                options={getOptionList('M00010')}
                                selectedValue={compValue('M00010')}
                                onChange={(val) => compChange('M00010', val)}
                            />
                            <div style={{height: "5px"}}/>
                            <div className={style.horizontalLine}></div>
                            <p className={style.content_typ1} style={{marginTop: "10px"}}>If yes, Medication</p>

                            <table style={{marginTop: "10px"}}>
                                <tbody>
                                <tr>
                                    <td className={style.content_typ1}>
                                        <Checkbox label={"Diet"}
                                                  onChange={(e) => e.target.checked ? props.setDtlValue('M00011', '1') : props.setDtlValue('M00011', '0')}
                                                  checked={props.getDtlValue('M00011') === '1'}
                                                  isDisabled={props.getDtlValue('M00011', 'activeFlag')}/>
                                    </td>
                                    <td className={style.content_typ1}>
                                        <Checkbox label={"insulin"}
                                                  onChange={(e) => e.target.checked ? props.setDtlValue('M00012', '1') : props.setDtlValue('M00012', '0')}
                                                  checked={props.getDtlValue('M00012') === '1'}
                                                  isDisabled={props.getDtlValue('M00012', 'activeFlag')}/>
                                    </td>
                                    <td className={style.content_typ1}>
                                        <Checkbox label={"Oral drug"}
                                                  onChange={(e) => e.target.checked ? props.setDtlValue('M00013', '1') : props.setDtlValue('M00013', '0')}
                                                  checked={props.getDtlValue('M00013') === '1'}
                                                  isDisabled={props.getDtlValue('M00013', 'activeFlag')}/>
                                    </td>
                                    <td className={style.content_typ1}>
                                        <Checkbox label={"Unknown"}
                                                  onChange={(e) => props.setDtlValue('M00014', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M00014') === '1'}
                                                  isDisabled={props.getDtlValue('M00014', 'activeFlag')}/>
                                    </td>

                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>Smoking</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00015')}
                            selectedValue={props.getDtlValue('M00015')}
                            onChange={(val) => props.setDtlValue('M00015', val)}
                        />
                    </div>
                    <div style={{height: "130px"}}>
                        <table>
                            <thead>
                            <tr>
                                <td>
                                    Dyslipidemia
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className={style.cellText2}>(고지혈증약 복용 중이거나, Total cholesterol 240mg/dL이상
                                        , LDL 160mg/dL이상, TG 200mg/dL 이상,HDL 40mg/dL이하-중 1개 이상)</span>
                                </td>
                            </tr>
                            </thead>
                        </table>

                    </div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00016')}
                            selectedValue={props.getDtlValue('M00016')}
                            onChange={(val) => props.setDtlValue('M00016', val)}
                        />
                    </div>
                    <div>Previous CABG</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00017')}
                            selectedValue={props.getDtlValue('M00017')}
                            onChange={(val) => props.setDtlValue('M00017', val)}
                        />
                    </div>
                    <div>Previous Myocardial Infarction</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00018')}
                            selectedValue={props.getDtlValue('M00018')}
                            onChange={(val) => props.setDtlValue('M00018', val)}
                        />
                    </div>
                    <div>Previous PCI</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00019')}
                            selectedValue={props.getDtlValue('M00019')}
                            onChange={(val) => props.setDtlValue('M00019', val)}
                        />
                    </div>
                    <div>Previous ISR Hx</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00020')}
                            selectedValue={props.getDtlValue('M00020')}
                            onChange={(val) => props.setDtlValue('M00020', val)}
                        />
                    </div>
                    <div>
                        <table>
                            <thead>
                            <tr>
                                <td>
                                    FHx of early coronary artery disease
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className={style.cellText2}>(부모형제자매-남 55 세 미만, 여 65 세 미만에서 CAD 발병한 경우)</span>
                                </td>
                            </tr>
                            </thead>
                        </table>

                    </div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00021')}
                            selectedValue={props.getDtlValue('M00021')}
                            onChange={(val) => props.setDtlValue('M00021', val)}
                        />
                    </div>
                    <div>Previous heart failure</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00022')}
                            selectedValue={props.getDtlValue('M00022')}
                            onChange={(val) => props.setDtlValue('M00022', val)}
                        />
                    </div>
                    <div>
                        <table>
                            <thead>
                            <tr>
                                <td>
                                    Previous cerebrovascular accident
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className={style.cellText2}>(TIA, 뇌경색, 뇌출혈 포함)</span>
                                </td>
                            </tr>
                            </thead>
                        </table>
                    </div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00023')}
                            selectedValue={props.getDtlValue('M00023')}
                            onChange={(val) => props.setDtlValue('M00023', val)}
                        />
                    </div>
                    <div>Chronic kidney disease</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup
                                        options={getOptionList('M00024')}
                                        selectedValue={props.getDtlValue('M00024')}
                                        onChange={(val) => compChange('M00024', val)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes, Dialysis <br/>
                                    <RadioGroup marginLeft={"20px"} disabled={props.getDtlValue('M00025', 'activeFlag')}
                                                options={getOptionList('M00025')}
                                                selectedValue={props.getDtlValue('M00025')}
                                                onChange={(val) => compChange('M00025', val)}
                                    />
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                    <div>History of cancer</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00028')}
                            selectedValue={props.getDtlValue('M00028')}
                            onChange={(val) => props.setDtlValue('M00028', val)}
                        />
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <div style={{display: "flex"}}>
                            <h3>입원 당시 약물 복용력 조사</h3>
                            <div className={style.verticalLine_sm} style={{backgroundColor: "black"}}/>
                            <h3>Anti-platelet and Anti-coagulant</h3>
                        </div>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                        <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                onClick={() => btnAllEvent('M00029')}>ALL NO</Button>
                            {insertSpace(2)}
                            <Button variant="Secondary" addStyle={{width: "100px", height: "40px"}}
                                    onClick={() => btnAllEvent('M00030')}>All Unknown</Button>
                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={3} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Aspirin</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M00031')} selectedValue={compValue('M00031')}
                                                onChange={(val) => compChange('M00031', val)}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>P2Y12 RI</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M00032')}
                                                selectedValue={compValue('M00032')}
                                                onChange={(val) => compChange('M00032', val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Clopidogrel" value="1"
                                                selectedValue={props.getDtlValue('M00033')}
                                                onChange={(val) => compChange('M00033', val)}
                                                disabled={props.getDtlValue('M00033', 'activeFlag')}/>
                                        <Radio2 label="Prasugrel" value="2" selectedValue={props.getDtlValue('M00033')}
                                                onChange={(val) => compChange('M00033', val)}
                                                disabled={props.getDtlValue('M00033', 'activeFlag')}/>

                                        (<Checkbox label={"10mg qd"}
                                                   onChange={(e) => props.setDtlValue('M00034', e.target.checked ? '1' : '0')}
                                                   checked={props.getDtlValue('M00034') === '1'}
                                                   isDisabled={props.getDtlValue('M00034', 'activeFlag')}/>
                                        <Checkbox label={"5mg qd"}
                                                  onChange={(e) => props.setDtlValue('M00035', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M00035') === '1'}
                                                  isDisabled={props.getDtlValue('M00035', 'activeFlag')}/>)
                                    </div>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Ticagrelor" value="3"
                                                selectedValue={props.getDtlValue('M00033')}
                                                onChange={(val) => compChange('M00033', val)}
                                                disabled={props.getDtlValue('M00033', 'activeFlag')}/>

                                        <span style={{marginTop: "7px"}}>(</span>
                                        <Checkbox label={"90mg qd"}
                                                  onChange={(e) => props.setDtlValue('M00036', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M00036') === '1'}
                                                  isDisabled={props.getDtlValue('M00036', 'activeFlag')}/>
                                        <Checkbox label={"90mg bid"}
                                                  onChange={(e) => props.setDtlValue('M00037', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M00037') === '1'}
                                                  isDisabled={props.getDtlValue('M00037', 'activeFlag')}/>
                                        <Checkbox label={"60mg bid"}
                                                  onChange={(e) => props.setDtlValue('M00038', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M00038') === '1'}
                                                  isDisabled={props.getDtlValue('M00038', 'activeFlag')}/>
                                        <Checkbox label={"45mg bid"}
                                                  onChange={(e) => props.setDtlValue('M00039', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M00039') === '1'}
                                                  isDisabled={props.getDtlValue('M00039', 'activeFlag')}/>
                                        <span style={{marginTop: "7px"}}>)</span>

                                        <Radio2 label="Other" value="4" selectedValue={props.getDtlValue('M00033')}
                                                onChange={(val) => compChange('M00033', val)}
                                                disabled={props.getDtlValue('M00033', 'activeFlag')}/>
                                        <InputUnitText value={props.getDtlValue('M00040')} maxLength={30}
                                                       onChange={(value) => props.setDtlValue("M00040", value)}
                                                       readOnly={props.getDtlValue('M00040', 'activeFlag')}/>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Cilostazol</div>
                    <div>
                        <RadioGroup options={getOptionList('M00041')}
                                    selectedValue={props.getDtlValue('M00041')}
                                    onChange={(val) => props.setDtlValue('M00041', val)}/>
                    </div>
                    <div>Anti-coagulant</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList('M00042')}
                                                selectedValue={compValue('M00042')}
                                                onChange={(val) => compChange('M00042', val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <div className={style.cellFlex}>
                                        <RadioGroup
                                            options={getOptionList('M00043')}
                                            colCnt={3}
                                            selectedValue={compValue('M00043')}
                                            onChange={(val) => compChange('M00043', val)}
                                            disabled={props.getDtlValue('M00043', 'activeFlag')}/>
                                        <InputUnitText marginTop={"35px"}
                                                       value={props.getDtlValue('M00044')}
                                                       maxLength={30} width={"300px"}
                                                       onChange={(value) => props.setDtlValue("M00044", value)}
                                                       readOnly={props.getDtlValue('M00044', 'activeFlag')}/>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <h3>Lipid modifying agent </h3>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                        <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                onClick={() => btnAllEvent('M00045')}>ALL NO</Button>
                            {insertSpace(2)}
                            <Button variant="Secondary" addStyle={{width: "100px", height: "40px"}}
                                    onClick={() => btnAllEvent('M00046')}>All Unknown</Button>
                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='defualt' rowCnt={3} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                    <div>Medication</div>
                    <div className={style.titleCell}>Ongoing</div>
                    <div>Medication</div>
                    <div className={style.titleCell}>Ongoing</div>
                    <div>Statin</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00047')}
                            selectedValue={props.getDtlValue('M00047')}
                            onChange={(val) => props.setDtlValue('M00047', val)}
                        />
                    </div>
                    <div>Ezetimibe</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M00048')}
                            selectedValue={props.getDtlValue('M00048')}
                            onChange={(val) => props.setDtlValue('M00048', val)}
                        />
                    </div>
                    <div>Fibrate</div>
                    <div className={"col_merge"}>
                        <RadioGroup
                            options={getOptionList('M00049')}
                            selectedValue={props.getDtlValue('M00049')}
                            onChange={(val) => props.setDtlValue('M00049', val)}
                        />
                    </div>
                </Table>
            </div>




        </>
    ;
    htmlTab3 =
        <>
            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <div style={{display: "flex"}}>
                            <h3>실험실적 검사</h3>
                            <div className={style.verticalLine_sm} style={{backgroundColor: "black"}}/>
                            <h3>Lab data</h3>
                        </div>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                            <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                    onClick={() => btnAllEvent('M10001')}>All ND</Button>
                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='Vertical' rowCnt={25} colSize={['25%', '50%', '50%']} rowSize={'56px'}>
                    <div>Medication</div>
                    <div>Initial</div>
                    <div>After procedure(peak/lowest)</div>
                    <div className={style.titleCell}>WBC(x10³/mm³)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10002')}
                                       onChange={(value) => props.setDtlValue('M10002', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10002', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>Hb(g/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10003')}
                                       onChange={(value) => props.setDtlValue('M10003', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10003', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Lowest<InputUnitText value={props.getDtlValue('M10004')}
                                             onChange={(value) => props.setDtlValue('M10004', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10004', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>Hct(%)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10005')}
                                       onChange={(value) => props.setDtlValue('M10005', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10005', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Lowest<InputUnitText value={props.getDtlValue('M10006')}
                                             onChange={(value) => props.setDtlValue('M10006', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10006', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>Platelet(x10³/mm³)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10007')}
                                       onChange={(value) => props.setDtlValue('M10007', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10007', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Lowest<InputUnitText value={props.getDtlValue('M10008')}
                                             onChange={(value) => props.setDtlValue('M10008', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10008', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>AST(GOT)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10009')}
                                       onChange={(value) => props.setDtlValue('M10009', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10009', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>ALT(GPT)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10010')}
                                       onChange={(value) => props.setDtlValue('M10010', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10010', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>Glucose(random)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10011')}
                                       onChange={(value) => props.setDtlValue('M10011', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10011', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>Creatinine(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10012')}
                                       onChange={(value) => compChange('M10012', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10012', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Peak
                        <InputUnitText value={props.getDtlValue('M10013')}
                                       onChange={(value) => compChange('M10013', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10013', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>
                        <span className={style.cellText2}>
                            <div className={style.cellText1}>eGFR(mL/min/1.73m2)</div>
                            MDRD:175*Scr^-1.154*나이^-0.203(여성이면*0.742)</span>
                    </div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10014')} readOnly={true}
                                       onChange={(value) => compChange('M10014', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10014', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10015')} readOnly={true}
                                       onChange={(value) => props.setDtlValue('M10015', value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10015', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>BUN(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10016')}
                                       onChange={(val) => props.setDtlValue('M10016', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10016', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Peak<InputUnitText value={props.getDtlValue('M10017')}
                                           onChange={(val) => props.setDtlValue('M10017', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10017', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>Total cholesterol(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10018')}
                                       onChange={(val) => props.setDtlValue('M10018', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10018', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>TG(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10019')}
                                       onChange={(val) => props.setDtlValue('M10019', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10019', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>HDL(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10020')}
                                       onChange={(val) => props.setDtlValue('M10020', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10020', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>LDL(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10021')}
                                       onChange={(val) => props.setDtlValue('M10021', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10021', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>hs-CRP(mg/dL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10022')}
                                       onChange={(val) => props.setDtlValue('M10022', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10022', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>CK(IU/L)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10023')}
                                       onChange={(val) => props.setDtlValue('M10023', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10023', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Peak<InputUnitText value={props.getDtlValue('M10024')}
                                           onChange={(val) => props.setDtlValue('M10024', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10024', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>CK-MB(ng/mL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10025')}
                                       onChange={(val) => props.setDtlValue('M10025', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10025', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.content_typ1_left}>
                        Peak<InputUnitText value={props.getDtlValue('M10026')}
                                           onChange={(val) => props.setDtlValue('M10026', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10026', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>Troponin T (ng/mL)(pg/mL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10027')}
                                       onChange={(val) => compChange('M10027', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => actNd('M10027', "ND")}>
                            ND
                        </Button>
                        <SelectBox
                            options={getOptionList('M10028')}
                            valueKey="value" labelKey="label"
                            value={props.getDtlValue('M10028')}
                            onChange={(val) => props.setDtlValue('M10028', val)}
                            width={'30%'} isDisabled={props.getDtlValue('M10028', 'activeFlag')}
                        />
                    </div>
                    <div className={style.content_typ1_left}>
                        Peak<InputUnitText value={props.getDtlValue('M10029')}
                                           onChange={(val) => compChange('M10029', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => actNd('M10029', "ND")}>
                            ND
                        </Button>
                        <SelectBox
                            options={getOptionList('M10030')}
                            valueKey="value" labelKey="label"
                            value={props.getDtlValue('M10030')} onChange={(val) => props.setDtlValue('M10030', val)}
                            width={'30%'} isDisabled={props.getDtlValue('M10030', 'activeFlag')}
                        />
                    </div>
                    <div className={style.titleCell}>Troponin I (ng/mL)(pg/mL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10031')}
                                       onChange={(val) => compChange('M10031', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => actNd('M10031', "ND")}>
                            ND
                        </Button>
                        <SelectBox
                            options={getOptionList('M10032')}
                            valueKey="value" labelKey="label"
                            value={props.getDtlValue('M10032')}
                            onChange={(val) => props.setDtlValue('M10032', val)}
                            width={'30%'} isDisabled={props.getDtlValue('M10032', 'activeFlag')}
                        />
                    </div>
                    <div className={style.content_typ1_left}>
                        Peak<InputUnitText value={props.getDtlValue('M10033')}
                                           onChange={(val) => compChange('M10033', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => actNd('M10033', "ND")}>
                            ND
                        </Button>
                        <SelectBox
                            options={getOptionList('M10034')}
                            valueKey="value" labelKey="label"
                            value={props.getDtlValue('M10034')}
                            onChange={(val) => props.setDtlValue('M10034', val)}
                            width={'30%'} isDisabled={props.getDtlValue('M10034', 'activeFlag')}
                        />
                    </div>
                    <div className={style.titleCell}>BNP(pg/mL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10035')}
                                       onChange={(val) => props.setDtlValue('M10035', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10035', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>Pro-BNP(pg/mL)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10036')}
                                       onChange={(val) => props.setDtlValue('M10036', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10036', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>PlateletReactivityUnits(PRU)</div>
                    <div></div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10037')}
                                       onChange={(val) => props.setDtlValue('M10037', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10037', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div className={style.titleCell}>HbA1C(%)</div>
                    <div className={style.content_typ1_left}>
                        <InputUnitText value={props.getDtlValue('M10038')}
                                       onChange={(val) => props.setDtlValue('M10038', val)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue('M10038', "ND")}>
                            ND
                        </Button>
                    </div>
                    <div></div>
                    <div className={style.titleCell}>HCG(Urine or Serum)</div>
                    <div className={style.content_typ1_left}>
                        <RadioGroup
                            options={getOptionList('M10039')}
                            selectedValue={props.getDtlValue('M10039')}
                            onChange={(val) => props.setDtlValue('M10039', val)}
                        />
                    </div>
                    <div></div>
                </Table>
            </div>
            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <h3>Non-Invasive Test (Pre-procedure)</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='defualt' rowCnt={2} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>EKG</div>
                    <div>
                        <Radio2 label="Done" value="1"
                                selectedValue={props.getDtlValue('M10040')}
                                onChange={(val) => compChange('M10040', val)}/>
                        [
                        <Checkbox label={"ST Change"}
                                  onChange={(e) => props.setDtlValue('M10041', e.target.checked ? '1' : '0')}
                                  checked={props.getDtlValue('M10041') === '1'}
                                  isDisabled={props.getDtlValue('M10041', 'activeFlag')}/>

                        <Checkbox label={"Q wave"}
                                  onChange={(e) => props.setDtlValue('M10042', e.target.checked ? '1' : '0')}
                                  checked={props.getDtlValue('M10042') === '1'}
                                  isDisabled={props.getDtlValue('M10042', 'activeFlag')}/>

                        ] {insertSpace(2)}

                        <Radio2 label="Not Done" value="2" selectedValue={props.getDtlValue('M10040')}
                                onChange={(val) => compChange('M10040', val)}/>
                    </div>
                    <div>Echo-cardiogram</div>
                    <div>
                        <Radio2 label="Done" value="1"
                                selectedValue={props.getDtlValue('M10043')}
                                onChange={(val) => compChange('M10043', val)}/>

                        (LVEF<InputUnitText type={"text"} value={props.getDtlValue('M10044')} unit={"%"}
                                            onChange={(value) => props.setDtlValue('M10044', value)}
                                            readOnly={props.getDtlValue('M10044', 'activeFlag')}/>)
                        {insertSpace(2)}

                        <Radio2 label="Not Done" value="2" selectedValue={props.getDtlValue('M10043')}
                                onChange={(val) => compChange('M10043', val)}/>
                    </div>

                </Table>
            </div>
        </>;

    htmlTab2 =
        <>
            <div className={styleCom.title_wrap}>
                <h3>관상동맥 조영술</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={10} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Angiography date</div>
                    <DatePicker selDate={ymdToDate(props.getDtlValue('M11001'))}
                                dateFormat={'yyyy-MM-dd'}
                                onChange={(date) => props.setDtlValue('M11001', dateToYMD(date))}/>
                    <div>
                        Medication related Cath lab.
                    </div>
                    <div>
                        <table className={style.customLine} style={{height: "250px"}}>
                            <tbody>
                            <tr>
                                <td style={{width: "190px", backgroundColor: "#FAFAFA"}}>Pre CAG Med. Loading</td>
                                <td>
                                    <Checkbox label={"No"}
                                              onChange={(e) => compChange('M11003', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11003') === '1'}
                                              isDisabled={props.getDtlValue('M11003', 'activeFlag')}/>
                                    <div style={{display: "flex", gap: "10px", marginTop: "15px"}}>
                                        <Checkbox label={"Aspirin"}
                                                  onChange={(e) => props.setDtlValue('M11004', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11004') === '1'}
                                                  isDisabled={props.getDtlValue('M11004', 'activeFlag')}/>
                                        <Checkbox label={"Clopidogrel 300mg"}
                                                  onChange={(e) => props.setDtlValue('M11005', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11005') === '1'}
                                                  isDisabled={props.getDtlValue('M11005', 'activeFlag')}/>
                                        <Checkbox label={"Clopidogrel 600mg"}
                                                  onChange={(e) => props.setDtlValue('M11006', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11006') === '1'}
                                                  isDisabled={props.getDtlValue('M11006', 'activeFlag')}/>
                                    </div>
                                    <div style={{display: "flex", gap: "10px", marginTop: "5px"}}>
                                        <Checkbox label={"Prasugrel 60mg"}
                                                  onChange={(e) => props.setDtlValue('M11007', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11007') === '1'}
                                                  isDisabled={props.getDtlValue('M11007', 'activeFlag')}/>
                                        <Checkbox label={"Ticagrelor 180mg"}
                                                  onChange={(e) => props.setDtlValue('M11008', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11008') === '1'}
                                                  isDisabled={props.getDtlValue('M11008', 'activeFlag')}/>
                                        <Checkbox label={"Other"}
                                                  onChange={(e) => compChange('M11009', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11009') === '1'}
                                                  isDisabled={props.getDtlValue('M11009', 'activeFlag')}/>
                                        <div><InputUnitText type={"text"} value={props.getDtlValue('M11010')}
                                                            onChange={(value) => props.setDtlValue('M11010', value)}
                                                            maxLength={30}
                                                            readOnly={props.getDtlValue('M11010', 'activeFlag')}/>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor: "#FAFAFA"}}>Heparin before cath. lab</td>
                                <td>
                                    <Checkbox label={"No"}
                                              onChange={(e) => compChange('M11011', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11011') === '1'}
                                              isDisabled={props.getDtlValue('M11011', 'activeFlag')}/>
                                    <div style={{display: "flex", gap: "10px", marginTop: "15px"}}>
                                        <Checkbox label={"UHF"}
                                                  onChange={(e) => props.setDtlValue('M11012', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11012') === '1'}
                                                  isDisabled={props.getDtlValue('M11012', 'activeFlag')}/>
                                        <Checkbox label={"Enoxaparin"}
                                                  onChange={(e) => props.setDtlValue('M11013', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11013') === '1'}
                                                  isDisabled={props.getDtlValue('M11013', 'activeFlag')}/>
                                        <Checkbox label={"Dalteparin"}
                                                  onChange={(e) => props.setDtlValue('M11014', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11014') === '1'}
                                                  isDisabled={props.getDtlValue('M11014', 'activeFlag')}/>
                                        <Checkbox label={"Nadroparin"}
                                                  onChange={(e) => props.setDtlValue('M11015', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11015') === '1'}
                                                  isDisabled={props.getDtlValue('M11015', 'activeFlag')}/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor: "#FAFAFA"}}>GPIIb/IIIainhibitor</td>
                                <td>
                                    <Checkbox label={"No"}
                                              onChange={(e) => compChange('M11016', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11016') === '1'}
                                              isDisabled={props.getDtlValue('M11016', 'activeFlag')}/>
                                    <div style={{display: "flex", gap: "10px", marginTop: "15px"}}>
                                        <Checkbox label={"Abciximab"}
                                                  onChange={(e) => props.setDtlValue('M11017', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11017') === '1'}
                                                  isDisabled={props.getDtlValue('M11017', 'activeFlag')}/>
                                        <Checkbox label={"Eptifibatide"}
                                                  onChange={(e) => props.setDtlValue('M11018', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11018') === '1'}
                                                  isDisabled={props.getDtlValue('M11018', 'activeFlag')}/>
                                        <Checkbox label={"Tirofiban"}
                                                  onChange={(e) => props.setDtlValue('M11019', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11019') === '1'}
                                                  isDisabled={props.getDtlValue('M11019', 'activeFlag')}/>

                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{backgroundColor: "#FAFAFA"}}>Renal adj therapy</td>
                                <td>
                                    <Checkbox label={"No"}
                                              onChange={(e) => compChange('M11020', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11020') === '1'}
                                              isDisabled={props.getDtlValue('M11020', 'activeFlag')}/>
                                    <div style={{display: "flex", gap: "10px", marginTop: "15px"}}>
                                        <Checkbox label={"N-acetylcystein"}
                                                  onChange={(e) => props.setDtlValue('M11021', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11021') === '1'}
                                                  isDisabled={props.getDtlValue('M11021', 'activeFlag')}/>
                                        <Checkbox label={"Bicarbonate solution"}
                                                  onChange={(e) => props.setDtlValue('M11022', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11022') === '1'}
                                                  isDisabled={props.getDtlValue('M11022', 'activeFlag')}/>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        Cardiac assist device
                    </div>
                    <div style={{height: "87px"}}>
                        <table>
                            <tbody>
                            <tr>
                                <td>
                                    <Checkbox label={"No"}
                                              onChange={(e) => compChange('M11023', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11023') === '1'}
                                              isDisabled={props.getDtlValue('M11023', 'activeFlag')}/>
                                    <div style={{display: "flex", gap: "10px", marginTop: "15px"}}>
                                        <Checkbox label={"IABP"}
                                                  onChange={(e) => props.setDtlValue('M11024', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11024') === '1'}
                                                  isDisabled={props.getDtlValue('M11024', 'activeFlag')}/>
                                        <Checkbox label={"ECMO"}
                                                  onChange={(e) => props.setDtlValue('M11025', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11025') === '1'}
                                                  isDisabled={props.getDtlValue('M11025', 'activeFlag')}/>
                                        <Checkbox label={"Other"}
                                                  onChange={(e) => compChange('M11026', e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue('M11026') === '1'}
                                                  isDisabled={props.getDtlValue('M11026', 'activeFlag')}/>
                                        <InputUnitText type={"text"} value={props.getDtlValue('M11027')}
                                                       maxLength={30} width={"300px"}
                                                       onChange={(value) => props.setDtlValue("M11027", value)}
                                                       readOnly={props.getDtlValue('M11027', 'activeFlag')}/>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <span className={style.cellText2}>
                            <div className={style.cellText1}>Extended disease lesion</div>
                            (Diseased lesion 의 정의 :<br/> {insertSpace(4)} 50% 이상의 협착을 가지는 혈관의 수)</span>
                    </div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M11028')}
                            selectedValue={props.getDtlValue('M11028')}
                            onChange={(val) => props.setDtlValue('M11028', val)}
                        />
                    </div>
                    <div>
                        Diseased vessel
                    </div>
                    <div style={{height: "56px"}}>
                        <table>
                            <tbody>
                            <tr>
                                <td style={{display: 'flex', gap: "10px"}}>
                                    <Checkbox label={"Left main"}
                                              onChange={(e) => props.setDtlValue('M11029', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11029') === '1'}
                                              isDisabled={props.getDtlValue('M11029', 'activeFlag')}/>
                                    <Checkbox label={"LAD"}
                                              onChange={(e) => props.setDtlValue('M11030', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11030') === '1'}
                                              isDisabled={props.getDtlValue('M11030', 'activeFlag')}/>
                                    <Checkbox label={"LCX"}
                                              onChange={(e) => props.setDtlValue('M11031', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11031') === '1'}
                                              isDisabled={props.getDtlValue('M11031', 'activeFlag')}/>
                                    <Checkbox label={"RCA"}
                                              onChange={(e) => props.setDtlValue('M11032', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11032') === '1'}
                                              isDisabled={props.getDtlValue('M11032', 'activeFlag')}/>
                                    <Checkbox label={"Ramus"}
                                              onChange={(e) => props.setDtlValue('M11033', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11033') === '1'}
                                              isDisabled={props.getDtlValue('M11033', 'activeFlag')}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        Treated vessel at this procedure
                    </div>
                    <div style={{height: "56px"}}>
                        <table>
                            <tbody>
                            <tr>
                                <td style={{display: 'flex', gap: "10px"}}>
                                    <Checkbox label={"Left main"}
                                              onChange={(e) => props.setDtlValue('M11034', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11034') === '1'}
                                              isDisabled={props.getDtlValue('M11034', 'activeFlag')}/>
                                    <Checkbox label={"LAD"}
                                              onChange={(e) => props.setDtlValue('M11035', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11035') === '1'}
                                              isDisabled={props.getDtlValue('M11035', 'activeFlag')}/>
                                    <Checkbox label={"LCX"}
                                              onChange={(e) => props.setDtlValue('M11036', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11036') === '1'}
                                              isDisabled={props.getDtlValue('M11036', 'activeFlag')}/>
                                    <Checkbox label={"RCA"}
                                              onChange={(e) => props.setDtlValue('M11037', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11037') === '1'}
                                              isDisabled={props.getDtlValue('M11037', 'activeFlag')}/>
                                    <Checkbox label={"Ramus"}
                                              onChange={(e) => props.setDtlValue('M11038', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11038') === '1'}
                                              isDisabled={props.getDtlValue('M11038', 'activeFlag')}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div> Total number of Stents at this procedure</div>
                    <div>
                        <InputUnitText value={props.getDtlValue('M11039')} unit={"ea"}
                                       onChange={(val) => props.setDtlValue('M11039', val)}
                                       readOnly={props.getDtlValue('M11039', 'activeFlag')}/>
                    </div>
                    <div>Access site</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup
                                        options={getOptionList('M11040')}
                                        selectedValue={compValue('M11040')}
                                        onChange={(val) => compChange('M11040', val)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{display: "flex", gap: "16px"}}>
                                    <Checkbox label={"Rt. Radial"}
                                              onChange={(e) => props.setDtlValue('M11041', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11041') === '1'}/>
                                    <Checkbox label={"Lt. Radial"}
                                              onChange={(e) => props.setDtlValue('M11042', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11042') === '1'}/>
                                    <Checkbox label={"Rt. Snuffbox"}
                                              onChange={(e) => props.setDtlValue('M11043', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11043') === '1'}/>
                                    <Checkbox label={"Lt. Snuffbox"}
                                              onChange={(e) => props.setDtlValue('M11044', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11044') === '1'}/>
                                </td>
                            </tr>
                            <tr>
                                <td style={{display: "flex", gap: "16px"}}>
                                    <Checkbox label={"Rt. Femoral"}
                                              onChange={(e) => props.setDtlValue('M11045', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11045') === '1'}/>
                                    <Checkbox label={"Lt. Femoral"}
                                              onChange={(e) => props.setDtlValue('M11046', e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue('M11046') === '1'}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Multiple access 사유, 최종 access site 기재</p>
                                    <TextArea value={props.getDtlValue('M11047')} height={'50%'}
                                              onChange={(val) => props.setDtlValue('M11047', val)}
                                              placeholder={"코멘트를 작성해 주세요"}
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Complete revascularization</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup
                                        options={getOptionList('M11048')}
                                        selectedValue={compValue('M11048')}
                                        onChange={(val) => compChange('M11048', val)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <RadioGroup
                                        options={getOptionList('M11049')}
                                        selectedValue={compValue('M11049')}
                                        onChange={(val) => compChange('M11049', val)}
                                        disabled={props.getDtlValue('M11049', 'activeFlag')}/>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Type of vascular hemostasis</div>
                    <div>
                        <RadioGroup
                            options={getOptionList('M11050')}
                            selectedValue={compValue('M11050')}
                            onChange={(val) => compChange('M11050', val)}
                        />
                    </div>


                </Table>
            </div>


        </>
    ;



    let renderHtml =
        <></>
    ;

    switch (props.contentId) {
        case "T0":
            renderHtml = htmlTab0;
            break;
        case "T1":
            renderHtml = htmlTab1;
            break;
        case "T2":
            renderHtml = htmlTab2;
            break;
        case "T12":
            renderHtml = htmlTab3;
            break;

        default:
            renderHtml = <>준비중 입니다.</>;
            break;
    }
    // if (props.contentId === "T0") {
    //     renderHtml = htmlTab0;
    // } else if (props.contentId === "T1") {
    //     renderHtml = htmlTab1;
    // } else if (props.contentId === "T2") {
    //     renderHtml = htmlTab2;
    // } else if (props.contentId === "T12") {
    //     renderHtml = htmlTab3;
    // } else {
    //     renderHtml = <>준비중 입니다.</>;
    // }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

